module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABSElEQVQ4T82Vv0rEQBDGv81tEwTrmAew8RX0HUQUrc5uAkmhaIprhO2uUItDyZ/FRsTmBAvfwMYXsLU2WJrimniOLOSaXM4ELoLbDTPfD3Zm9luByiGiQwATrfVDNdcmFjXAAYAhgEvXdQdKqa82oFnNHNDzvF1mHgMwuWfbtvdHo9FHW+gc0AiJaFsIccvMqwDepZR7URS9tIHWAo0wCIL1oigeAWwAKCzLOkmS5LoJuhBohGEYruR5fgPgwMRCiHtmJq31ZBH4V+BM5HneEYALZpYAXqWUO1EUvdVBWwHLvm4CMMNaA/DZ6/X6cRw/VaGtgUbo+74znU7HzLwFgC3LGjqOc6aU+l64Nk1NV0rJLMvOmfm4rL3TWvf/B7DTKxNRd0PpbG06Xezq0xNCnKZpetW0BX9vDqV9zcx1efsiom4Ndtkv4Ae4cbIVROiWggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ico-tri.png
// module id = SdKo
// module chunks = 1